module.exports = __webpack_public_path__ + "img/BiographiePhoto.574afa4b.png";